var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinDollarNotFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 6C11.4477 6 11 6.44772 11 7H10.7434C9.22827 7 8 8.22827 8 9.74342C8 10.9243 8.75562 11.9726 9.87587 12.3461L13.4917 13.5513C13.7952 13.6525 14 13.9366 14 14.2566C14 14.6672 13.6672 15 13.2566 15H12H11C10.4477 15 10 14.5523 10 14C10 13.4477 9.55228 13 9 13C8.44772 13 8 13.4477 8 14C8 15.6569 9.34315 17 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17H13.2566C14.7717 17 16 15.7717 16 14.2566C16 13.0757 15.2444 12.0274 14.1241 11.6539L10.5083 10.4487C10.2048 10.3475 10 10.0634 10 9.74342C10 9.33284 10.3328 9 10.7434 9H12H13C13.5523 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10C16 8.34315 14.6569 7 13 7C13 6.44772 12.5523 6 12 6Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinDollarNotFilled);
export default __webpack_public_path__ + "static/media/coin-dollar-not-filled.3043d095cecaa17ec12ac7efccf06b94.svg";
export { ForwardRef as ReactComponent };